// import client from './client'

export default {
}



// WEBPACK FOOTER //
// ./src/apis/admin-api/author.js